import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import menu from './modules/menu' // 引入模块
import tagsView from './modules/tagsViews'
import pm from './modules/pm'

// 加载 状态模块
export default new Vuex.Store({
    modules: {
        menu,
        tagsView,
        pm
    }
})